import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";

const usePutUserVerifiedAge: () => UseMutationResult = () =>
  useMutation({
    mutationFn: async () => {
      const response = await api("TRENDARO_API_URL").put(`/users/me/profile`, {
        json: {flags: ["verifiedAge"]},
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(
          `HTTP ${response.status} při odesílání ověření věku uživatele. (${data.error})`,
        );
      }

      return true;
    },
  });

export default usePutUserVerifiedAge;
